import { createContext } from "react";

export type OpenCreateSidebarOptions = {
  invoiceNumber: string;
  memberId: string;
};

interface PaymentsSidebarProviderContextType {
  openUserStaffPaymentsSidebar: (options: OpenCreateSidebarOptions) => void;
}

const defaultContext: PaymentsSidebarProviderContextType = {
  openUserStaffPaymentsSidebar: () => {
    throw new Error(
      "openCreateTaskSidebar function must be used within CreateEditTaskSidebarProvider",
    );
  },
};

export const PaymentsSidebarProviderContext =
  createContext<PaymentsSidebarProviderContextType>(defaultContext);
